import rtlPlugin from 'stylis-plugin-rtl'
import { CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache'
import moment from 'moment'
import Cookies from 'js-cookie';
import UseTranslation from '../../hooks/UseTranslation'
import 'moment/locale/ar'

const RTL = ({ children }) => {
  const { language } = UseTranslation()
  const cacheRtl = createCache({
    key: language === 'AR' ? 'mui-rtl' : 'css',
    stylisPlugins: language === 'AR' && [rtlPlugin],
    speedy: true,
  });

  moment.locale(Cookies.get('language') === 'AR' ? 'ar' : 'en');
  return (
    <CacheProvider value={cacheRtl}>

      {children}

    </CacheProvider>
  )
}

export default RTL
